import React, { useState, useEffect } from "react";
import PagesHeader from "../../components/PageHeader";
import ButtonBar from "../../components/ButtonNavigation/index";
import * as InstallerData from "../../services/InstallerData";
import { useDispatch } from "react-redux";
import { Row, Col, Card, Button, Divider, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import { EditOutlined, ArrowLeftOutlined, BankOutlined, EnvironmentOutlined, LockOutlined, EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";

const SingleInstaller = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  const queryParams = new URLSearchParams(window.location.search);
  const user_id = queryParams.get("user_id");

  useEffect(() => {
    if (user_id) {
      setLoading(true);
      dispatch(InstallerData.getSingleInstaller(user_id))
        .then((res) => {
          setData(res);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [dispatch, user_id]);

  const cardStyle = {
    borderRadius: "16px",
    border: "1px solid #cbd5e1",
    boxShadow: "0 10px 25px rgba(10, 73, 123, 0.05)",
    marginBottom: "24px",
    background: "#ffffff",
    overflow: "hidden",
  };

  const headerBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    background: "linear-gradient(135deg, #0a497b 0%, #0284c7 100%)",
    color: "#ffffff",
    fontSize: "16px",
    marginRight: "10px",
  };

  const labelStyle = {
    fontWeight: 600,
    color: "#64748b",
    fontSize: "13px",
    marginBottom: "4px",
    display: "block",
  };

  const valueStyle = {
    fontWeight: 600,
    color: "#0f172a",
    fontSize: "15px",
    margin: 0,
    wordBreak: "break-word",
  };

  return (
    <div className="inspectionWrapper" style={{ background: "#f8fafc", minHeight: "100vh", paddingBottom: "40px" }}>
      <div className="inspectionHeader">
        <PagesHeader title="Installer Profile Details" type="secondary" />
      </div>
      <div className="buttonSection" style={{ position: "relative", zIndex: 100 }}>
        <div className="container-xxl">
          <Row align="middle" justify="space-between">
            <Col xs={24} md={16} className="text-end">
              <ButtonBar />
            </Col>
            <Col xs={24} md={8} className="text-end">
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => navigate(`/installer-update/?user_id=${user_id}`)}
                style={{
                  borderRadius: "20px",
                  fontWeight: 600,
                  background: "linear-gradient(135deg, #0a497b 0%, #0284c7 100%)",
                  borderColor: "transparent",
                  boxShadow: "0 4px 12px rgba(2, 132, 199, 0.25)",
                }}
              >
                Edit Profile
              </Button>
            </Col>
          </Row>
        </div>
      </div>

      <div className="inspectionWrapInner mt-3">
        <div className="container-xxl" style={{ maxWidth: "1100px" }}>
          {loading ? (
            <Card style={cardStyle}>
              <Skeleton active paragraph={{ rows: 10 }} />
            </Card>
          ) : data ? (
            <div>
              {/* 1. Company Information Card */}
              {data.company_info === "enable" || data.comp_name || data.comp_email || data.phone ? (
                <Card style={cardStyle}>
                  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
                    <span style={headerBadgeStyle}>
                      <BankOutlined />
                    </span>
                    <h5 style={{ margin: 0, fontWeight: 700, color: "#0f172a", fontSize: "16px" }}>
                      Company Information
                    </h5>
                  </div>
                  <Divider style={{ margin: "12px 0 20px 0" }} />
                  <Row gutter={[20, 20]}>
                    {data.comp_name && (
                      <Col xs={24} sm={12} md={6}>
                        <span style={labelStyle}>Company Name</span>
                        <p style={valueStyle}>{data.comp_name}</p>
                      </Col>
                    )}
                    {data.website && (
                      <Col xs={24} sm={12} md={6}>
                        <span style={labelStyle}>Website</span>
                        <p style={valueStyle}>
                          <a href={data.website.startsWith("http") ? data.website : `https://${data.website}`} target="_blank" rel="noreferrer">
                            {data.website}
                          </a>
                        </p>
                      </Col>
                    )}
                    {data.comp_email && (
                      <Col xs={24} sm={12} md={6}>
                        <span style={labelStyle}>Email</span>
                        <p style={valueStyle}>{data.comp_email}</p>
                      </Col>
                    )}
                    {data.phone && (
                      <Col xs={24} sm={12} md={6}>
                        <span style={labelStyle}>Phone</span>
                        <p style={valueStyle}>{data.phone}</p>
                      </Col>
                    )}
                    {data.comp_type && (
                      <Col xs={24} sm={12} md={6}>
                        <span style={labelStyle}>Company Type</span>
                        <p style={valueStyle}>{data.comp_type}</p>
                      </Col>
                    )}
                  </Row>
                </Card>
              ) : null}

              {/* 2. Mailing and Shipping Address Card */}
              {data.shipping_info === "enable" || data.street || data.city || data.state || data.country || data.zip_code ? (
                <Card style={cardStyle}>
                  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
                    <span style={headerBadgeStyle}>
                      <EnvironmentOutlined />
                    </span>
                    <h5 style={{ margin: 0, fontWeight: 700, color: "#0f172a", fontSize: "16px" }}>
                      Mailing and Shipping Address
                    </h5>
                  </div>
                  <Divider style={{ margin: "12px 0 20px 0" }} />
                  <Row gutter={[20, 20]}>
                    {data.street && (
                      <Col xs={24} sm={12} md={6}>
                        <span style={labelStyle}>Street</span>
                        <p style={valueStyle}>{data.street}</p>
                      </Col>
                    )}
                    {data.city && (
                      <Col xs={24} sm={12} md={6}>
                        <span style={labelStyle}>City</span>
                        <p style={valueStyle}>{data.city}</p>
                      </Col>
                    )}
                    {data.state && (
                      <Col xs={24} sm={12} md={6}>
                        <span style={labelStyle}>State</span>
                        <p style={valueStyle}>{data.state}</p>
                      </Col>
                    )}
                    {data.country && (
                      <Col xs={24} sm={12} md={6}>
                        <span style={labelStyle}>Country</span>
                        <p style={valueStyle}>{data.country}</p>
                      </Col>
                    )}
                    {data.zip_code && (
                      <Col xs={24} sm={12} md={6}>
                        <span style={labelStyle}>Zip Code</span>
                        <p style={valueStyle}>{data.zip_code}</p>
                      </Col>
                    )}
                  </Row>
                </Card>
              ) : null}

              {/* 3. Login Information Card */}
              <Card style={cardStyle}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
                  <span style={headerBadgeStyle}>
                    <LockOutlined />
                  </span>
                  <h5 style={{ margin: 0, fontWeight: 700, color: "#0f172a", fontSize: "16px" }}>
                    Login Information
                  </h5>
                </div>
                <Divider style={{ margin: "12px 0 20px 0" }} />
                <Row gutter={[20, 20]}>
                  {(data.email_add || data.user_name) && (
                    <Col xs={24} sm={12} md={6}>
                      <span style={labelStyle}>Email Address (Login ID)</span>
                      <p style={valueStyle}>{data.email_add || data.user_name}</p>
                    </Col>
                  )}
                  {data.user_name && data.email_add && data.user_name !== data.email_add && (
                    <Col xs={24} sm={12} md={6}>
                      <span style={labelStyle}>Username</span>
                      <p style={valueStyle}>{data.user_name}</p>
                    </Col>
                  )}
                  {data.password && (
                    <Col xs={24} sm={12} md={6}>
                      <span style={labelStyle}>Password</span>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <p style={{ ...valueStyle, letterSpacing: showPassword ? "normal" : "2px" }}>
                          {showPassword ? data.password : "••••••••"}
                        </p>
                        <Button
                          type="text"
                          size="small"
                          icon={showPassword ? <EyeInvisibleOutlined style={{ color: "#0a497b", fontSize: "16px" }} /> : <EyeOutlined style={{ color: "#0a497b", fontSize: "16px" }} />}
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ padding: "0 4px", display: "flex", alignItems: "center" }}
                        />
                      </div>
                    </Col>
                  )}
                  {data.first_name && (
                    <Col xs={24} sm={12} md={6}>
                      <span style={labelStyle}>First Name</span>
                      <p style={valueStyle}>{data.first_name}</p>
                    </Col>
                  )}
                  {data.last_name && (
                    <Col xs={24} sm={12} md={6}>
                      <span style={labelStyle}>Last Name</span>
                      <p style={valueStyle}>{data.last_name}</p>
                    </Col>
                  )}
                  {data.phone_personal && (
                    <Col xs={24} sm={12} md={6}>
                      <span style={labelStyle}>Personal Phone</span>
                      <p style={valueStyle}>{data.phone_personal}</p>
                    </Col>
                  )}
                </Row>
              </Card>

              {/* Back Action Bar */}
              <div className="mt-4 text-start">
                <Button
                  size="large"
                  icon={<ArrowLeftOutlined />}
                  onClick={() => navigate("/all-installers")}
                  style={{
                    borderRadius: "10px",
                    fontWeight: 600,
                    borderColor: "#cbd5e1",
                    color: "#475569",
                  }}
                >
                  Back to Listing
                </Button>
              </div>
            </div>
          ) : (
            <Card style={cardStyle}>
              <p>Installer details not found.</p>
            </Card>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleInstaller;
